export default "__VITE_ASSET__B2M2Y5jI__"